module.exports = __webpack_public_path__ + "static/img/12.82370e2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/8/zh/12.png
// module id = JxZE
// module chunks = 0